var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":"Motivos Preço Negociado"}},[_c('crud-base',{attrs:{"url":_vm.url,"columns":_vm.columns,"onDelete":() => {},"onUpdate":() => {},"onStore":() => {},"enableSearch":true,"checkAlerts":true,"formInputs":_vm.formInputs,"primaryKey":"id"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }